import { NormalizedNumber } from '@sparkdotfi/common-universal'
import { BigNumber } from 'bignumber.js'

import { useMarketInfoWethPriceStore } from '@/domain/state/market-info-weth-price'
import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { CopyableContentTooltip } from '@/ui/molecules/copyable-content-tooltip/CopyableContentTooltip'

export interface TokenAmountTooltipProps {
  amount: NormalizedNumber
  token: Token
  options: {
    style: 'compact' | 'auto' | 'auto-precision-1-usd'
    showSymbol: 'always' | 'only-tooltip-trigger' | 'only-tooltip-content' | 'never'
  }
  className?: string
}

const ETH_YIELD_BEARING_ASSETS = ['wstETH', 'rETH', 'weETH', 'ezETH', 'rsETH'].map(TokenSymbol)

export function TokenAmountTooltip({ amount, token, options, className }: TokenAmountTooltipProps) {
  const { style, showSymbol = 'never' } = options
  const wethPrice = useMarketInfoWethPriceStore((state) => state.wethPrice)
  const tokenToWethRatio =
    ETH_YIELD_BEARING_ASSETS.includes(token.symbol) && wethPrice && !wethPrice.isZero()
      ? token.unitPriceUsd.div(wethPrice)
      : undefined

  return (
    <CopyableContentTooltip
      className={className}
      content={[
        {
          label: `${token.format(amount, { style: 'auto' })}${['always', 'only-tooltip-content'].includes(showSymbol) ? ` ${token.symbol}` : ''}`,
          textToCopy: amount.decimalPlaces(token.decimals, BigNumber.ROUND_DOWN).toString(),
        },
        ...(tokenToWethRatio
          ? [
              {
                label: `≈${token.format(amount.times(tokenToWethRatio), { style: 'auto' })} ETH`,
                textToCopy: amount
                  .times(tokenToWethRatio)
                  .decimalPlaces(token.decimals, BigNumber.ROUND_DOWN)
                  .toString(),
              },
            ]
          : []),
      ]}
    >
      {token.format(amount, { style })}
      {['always', 'only-tooltip-trigger'].includes(showSymbol) ? ` ${token.symbol}` : ''}
    </CopyableContentTooltip>
  )
}
